<template>
    <tablecustom @search="searchB" :columns="columns" :rows="filteredItems" @open="open"/>
    <template v-if="showModal == true" >
        <viewpay @close="showModal = false" :shortapplic="cardApplic"/>
    </template>
</template>

<script>
import tablecustom from '@/components/globaltable/index';
import { mutateServices } from '@/usabilityScripts/globalMutate.js'
// import viewpay from './view'

export default {
    props: ['obj'],
    components: { tablecustom },
    data() {
        return {
            form: {},
            search: "",
            cardApplic: "",
            showModal: false,
            infoblockShow: false,
            columns: [
                {
                    name: this.$t("servicePackage"),
                    text: "service_title",
                    align: "right",
                },
                {
                    name: this.$t("Sum"),
                    text: "service_cost",
                    align: "left",
                },
                {
                    name: this.$t("date"),
                    text: "create_datetime",
                    align: "left",
                }
          ],
          information: [
                {
                    title: this.$t('Total'),
                    value: "0",
                    icon: "las la-file-invoice",
                    color: "info",
                    sum: "0"
                }
            ]
        }
    },
    created(){
        this.getdata()
    },
    methods: {
        getdata(){
            this.form = this.obj;
            for(var value in this.form) {
                this.form[value].service_title = this.mutate_services(this.form[value].service_title)
            }
        },
        mutate_services(e){
            return mutateServices(e)
        },
        arraySum(array){
            var sum = 0;
            for(var i = 0; i < array.length; i++){
                sum += Number(array[i].service_cost);
            }
            return sum
        },
        searchB(e){
            this.search = e
        },
        // open(e){
        //     this.cardApplic = e;
        //     this.showModal = true;
        // },
    },
    computed: {
        filteredItems: function() {
            return Object.values(this.form)
                // По полю поиска
                .filter(item => {
                    return this.search == '' || item.service_title.toString().toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
                })

        },
    }
}
</script>